import axios from "axios";

export const SITE_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${SITE_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("tc_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const fetchBlogs = () => api.get("/blogs").then((r) => r.data);
export const fetchBlog = (slug) => api.get(`/blogs/${slug}`).then((r) => r.data);
export const fetchDownloadSettings = () => api.get("/settings/download").then((r) => r.data);
export const fetchJobs = () => api.get("/jobs").then((r) => r.data);

export const SOCIALS = [
  { name: "LinkedIn", icon: "fa-brands fa-linkedin-in", url: "https://www.linkedin.com/company/crejik", id: "linkedin" },
  { name: "Instagram", icon: "fa-brands fa-instagram", url: "https://www.instagram.com/thetrucitizen", id: "instagram" },
  { name: "X", icon: "fa-brands fa-x-twitter", url: "https://x.com/TruCitizenHQ", id: "x" },
  { name: "YouTube", icon: "fa-brands fa-youtube", url: "https://www.youtube.com/@TruCitizen", id: "youtube" },
  { name: "Facebook", icon: "fa-brands fa-facebook-f", url: "https://www.facebook.com/profile.php?id=61594415700182", id: "facebook" },
];

export const SUPPORT_EMAIL = "support@crejik.com";
export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent("[TruCitizen] ")}`;

export const formatApiError = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return String(d);
};
